import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataTableComponent from '../../common/DataTable/PrimeDataTable';
import ActivateDeactivateModal from '../../common/ActivateDeactivateModal';
import { convertUTCToLocal } from '../../utils/dateUtils';

const CategoryOrganizationUsers = ({ persona }) => {
  const { categoryId, orgId } = useParams();
  const location = useLocation();
  const [t] = useTranslation();
  const [data, setData] = useState(null);
  const [categoryData, setCategoryData] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [confirmActivateModal, setConfirmActivateModal] = useState({
    open: false,
    record: null,
  });
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'createdAt',
    sortOrder: -1,
  });

  useEffect(() => {
    fetchOrganizationUsers();
    // fetch category data if not in location.state
    if (!location.state?.category) {
      fetchCategoryData();
    } else {
      setCategoryData(location.state.category);
    }
  }, [paginationParams]);

  const fetchCategoryData = async () => {
    const response = await axiosInstance
      .get(`${process.env.REACT_APP_SERVER_URL}/api/categories/${categoryId}`, {
        withCredentials: true,
      })
      .catch((err) => {
        console.log(err);
      });

    if (response?.data) {
      setCategoryData({ name: response.data.name });
    }
  };

  const fetchOrganizationUsers = async () => {
    const response = await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/api/categories/${categoryId}/organizations/${orgId}/users`,
        {
          withCredentials: true,
        }
      )
      .catch((err) => {
        console.log(err);
      });

    console.log('Organization Users Response:', response?.data);

    setData(response?.data);
    setUsersData(response?.data?.users || []);
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder,
    }));
  };

  const columns = [
    {
      field: 'id',
      header: 'ID',
      sortable: true,
      body: (rowData) => rowData.id,
    },
    {
      field: 'username',
      header: t('Username'),
      sortable: true,
      filter: true,
      body: (rowData) => rowData.username,
    },
    {
      field: 'email',
      header: t('Email'),
      sortable: true,
      filter: true,
      body: (rowData) => rowData.email,
    },
    {
      field: 'first_name',
      header: t('First Name'),
      sortable: true,
      filter: true,
      body: (rowData) => rowData.first_name,
    },
    {
      field: 'last_name',
      header: t('Last Name'),
      sortable: true,
      filter: true,
      body: (rowData) => rowData.last_name,
    },
    {
      field: 'createdAt',
      header: t('createdAt'),
      sortable: true,
      filter: true,
      body: (rowData) => convertUTCToLocal(rowData.createdAt),
    },
  ];

  const actions = [
    {
      text: 'Activate / Deactivate',
      color: 'primary',
      onClick: (row) => setConfirmActivateModal({ open: true, record: row }),
      status: 'success',
    },
  ];

  return (
    <div>
      <DataTableComponent
        data={usersData}
        columns={columns}
        actions={actions}
        totalRecords={usersData?.length}
        enableCreate={false}
        enablePagination={true}
        paginationParams={paginationParams}
        onDataTableEvent={onDataTableEvent}
        enableLazyLoading={false}
        enableExport={true}
      />

      {confirmActivateModal.open && (
        <ActivateDeactivateModal
          sentData={confirmActivateModal.record}
          onEvent={setConfirmActivateModal}
          onConfirm={fetchOrganizationUsers}
          apiPath="endUsers"
          axios={axiosInstance}
          columnName="username"
          dbAction="active"
        />
      )}
    </div>
  );
};

export default CategoryOrganizationUsers;
